import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 0, text: "0%" },
  { value: 8, text: "8%" },
  { value: 10, text: "10%" },
]);
